import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'types',
      type: 'cascader',
      label: '素材分类',
      placeholder: '请搜索或选择素材分类',
      rules: { required: true, message: '素材分类不能为空', trigger: 'blur' }
    },
    {
      field: 'title',
      type: 'input',
      label: '素材标题',
      placeholder: '请输入素材标题',
      rules: { required: true, message: '素材标题不能为空', trigger: 'blur' }
    },
    {
      field: 'url',
      type: 'input',
      label: '访问链接',
      placeholder: '请输入访问链接',
      rules: { required: true, message: '访问链接不能为空', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
